import { AlertPoliciesEnum } from "@flexidao/dto";

export const formatAlertPolicy = (alertPolicy: AlertPoliciesEnum): string => {
    switch (alertPolicy) {
        case AlertPoliciesEnum.DataCompleteness75to95:
            return "Data completeness between 75% and 95%";
        case AlertPoliciesEnum.DataCompletenessBelow75:
            return "Data completeness below 75%";
        case AlertPoliciesEnum.DataDelayUnavailable:
            return "Data delay unavailable";
        case AlertPoliciesEnum.DataDelay1to30:
            return "Data delay between 1 and 30 days";
        case AlertPoliciesEnum.DataDelayOver30:
            return "Data delay over 30 days";
    }
};
